import { Form, Formik } from 'formik';
import { useState } from 'react';
import { CheckboxField } from '../../Components/Formik/BaseCheckBoxField';
import { TextField } from '../../Components/Formik/BaseTextField';
import { FileField } from '../../Components/Formik/FileField';
import { TextareaField } from '../../Components/Formik/TextAreaField';
import Api from '../../api';

const TributePanel = ({
  open,
  onClose,
  serviceHash,
  hasPrimaryContact,
}: {
  open: boolean;
  onClose: () => void;
  serviceHash: string;
  hasPrimaryContact: boolean;
}) => {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [successful, setSuccessful] = useState(true);
  const [tributeCharacterCount, setTributeCharacterCount] = useState(0);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  if (!open) return null;

  if (hasSubmitted) {
    if (successful) {
      return <div className="tribute-success">Thank you for your message.</div>;
    }

    return <div className="tribute-fail">Your tribute failed to submit. Please contact us.</div>;
  }

  const formikProps = {
    initialValues: {
      name: '',
      email: '',
      tribute: '',
      location: '',
      public: true,
      show_email: true,
      image: null,
    },
    onSubmit: async (values) => {
      return Api.addTribute({
        hash: serviceHash,
        data: values,
      })
        .then(() => {
          setHasSubmitted(true);
        })
        .catch((e) => {
          console.log(e);
          setHasSubmitted(true);
          setSuccessful(false);
        });
    },
  };

  return (
    <div>
      <Formik
        {...formikProps}
        validate={(values) => {
          const errors: any = {};
          if (!values.name) {
            errors.name = 'Please enter your name';
          }

          if (values.name.length > 50) {
            errors.name = 'Please enter a name less than 50 characters';
          }

          if (!values.email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) {
            errors.email = 'Please enter a valid email address';
          }

          if (!values.email) {
            errors.email = 'Please enter your email address';
          }

          if (!values.tribute) {
            errors.tribute = 'Please provide your tribute.';
          }

          if (!/[a-zA-Z0-9]/.test(values?.tribute)) {
            errors.tribute = 'Please provide your tribute.';
          }

          return errors;
        }}
      >
        {({ values, handleChange, handleBlur, setFieldValue, errors, touched, isSubmitting }) =>
          isSubmitting ? (
            <div className="tribute-loader-container">
              <div className="loader"></div>
            </div>
          ) : (
            <Form>
              <div className="add-tribute-container">
                <h4 className="add-tribute-title">Leave a tribute</h4>

                <div className="tribute-form-fields">
                  <div className="tribute-text-fields">
                    <div className="field-container">
                      <TextField autoFocus placeholder="Name" name="name" onChange={handleChange} onBlur={handleBlur} value={values.name} />
                      {errors.name && touched.name && <div className="tribute-form-validation">{errors.name.toString()}</div>}
                    </div>

                    <div className="field-container">
                      <TextField placeholder="Email address" name="email" onChange={handleChange} onBlur={handleBlur} value={values.email} />
                      {errors.email && touched.email && <div className="tribute-form-validation">{errors.email.toString()}</div>}
                    </div>
                    <div className="field-container">
                      <TextField
                        placeholder="From/Of/Your connection (optional)"
                        name="location"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.location}
                      />
                    </div>
                    <div className="field-container">
                      <div className="relative">
                        <TextareaField
                          placeholder="Tribute"
                          name="tribute"
                          onChange={(value) => {
                            setTributeCharacterCount(value.target.value.length);
                            handleChange(value);
                          }}
                          onBlur={handleBlur}
                          maxLength="2000"
                          value={values.tribute}
                        />
                        <div className="characters-remaining">Characters remaining {2000 - tributeCharacterCount}</div>
                      </div>
                      {errors.tribute && touched.tribute && <div className="tribute-form-validation">{errors.tribute.toString()}</div>}
                    </div>

                    <div className="check-box-fields">
                      <div className="checkbox-field-wrapper">
                        <CheckboxField name="public" onChange={handleChange} onBlur={handleBlur} checked={values.public} />
                        <span>Show tribute publicly</span>
                      </div>

                      <div className="checkbox-field-wrapper">
                        <CheckboxField name="show_email" onChange={handleChange} onBlur={handleBlur} checked={values.show_email} />
                        <span>Allow family to see my email address</span>
                      </div>
                    </div>
                  </div>

                  <div className="tribute-image-container">
                    {imageUrl ? <img src={imageUrl!} alt="img" /> : null}
                    <FileField
                      name="image"
                      accept="images"
                      onChange={(file) => {
                        setFieldValue('image', file);
                        setImageUrl(URL.createObjectURL(file));
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="add-tribute-footer">
                <button type="submit" className="save-tribute-button">
                  Submit
                </button>
                <button type="button" className="plain-button" onClick={onClose}>
                  Cancel
                </button>
              </div>
            </Form>
          )
        }
      </Formik>
    </div>
  );
};

export default TributePanel;
